#import "./assignmentProposalListFields.fragment.graphql"

# The proposals of a link waiting for the logged reviewer, with their change summary. The backend
# decides what each reviewer sees (the chosen intermediate reviewer, or the whole pool for a final
# reviewer) and what they may do with each proposal (`allowedActions`).
query assignmentProposalsForReview($scenarioId: ID!, $originId: ID!, $linkId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    assignmentProposalsForReview(linkId: $linkId) {
      errorCode
      proposals {
        ...ProposalListFields
        allowedActions
        __typename
      }
      __typename
    }
    __typename
  }
}
